import { Component, OnInit } from '@angular/core';
import { AppService } from '../app.service';

@Component({
  selector: 'app-topics',
  templateUrl: './topics.component.html',
  styleUrls: ['../../General/tiles.css', './topics.component.css']
})
export class TopicsComponent implements OnInit {

  allTopics: any[] = null;

  constructor(public appService: AppService) { }

  ngOnInit() {
    this.allTopics = this.appService.getAllTopics();
  }

  /** get text in right language 
  * @param {string} tag - text to load
  */
 get(tag:string):String {
	return this.appService.get(tag);
  }

}
